export const rootPaths = {
  root: "/",
  dashboardRoot: "dashboard",

  authRoot: "authentication",
  authSimpleRoot: "simple",
  authCardRoot: "card",
  authSplitRoot: "split",

  olitaskRoot: "olitask",
  accountRoot: "account",
  generalRoot: "general",

  pagesRoot: "pages", // <-- changed from 'pages' to 'olitask'
  userRoot: "users", // add this if you use userRoot in userProfile path
  accessControlRoot: "access-control",
};

export default {
  changelog: "/changelog",
  widgets: "/widgets",
  landing: "/landing",
  error404: `/${rootPaths.errorsRoot}/404`,
  error500: `/${rootPaths.errorsRoot}/500`,
  simpleLogin: `/${rootPaths.authRoot}/${rootPaths.authSimpleRoot}/login`,
  simpleRegister: `/${rootPaths.authRoot}/${rootPaths.authSimpleRoot}/register`,
  simpleLogout: `/${rootPaths.authRoot}/${rootPaths.authSimpleRoot}/logout`,
  simpleForgotPassword: `/${rootPaths.authRoot}/${rootPaths.authSimpleRoot}/forgot-password`,
  simpleVerificationCode: `/${rootPaths.authRoot}/${rootPaths.authSimpleRoot}/verification-code`,
  simpleResetPassword: `/${rootPaths.authRoot}/${rootPaths.authSimpleRoot}/reset-password`,
  simpleAccountRecoverySuccess: `/${rootPaths.authRoot}/${rootPaths.authSimpleRoot}/account-recovery-success`,
  splitForgotPassword: `/${rootPaths.authRoot}/${rootPaths.authSplitRoot}/forgot-password/verify`,
  splitResetPassword: `/${rootPaths.authRoot}/${rootPaths.authSplitRoot}/reset-password`,

  cardLogin: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/login`,
  cardRegister: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/register`,
  cardLogout: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/logout`,
  cardForgotPassword: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/forgot-password`,
  cardResetPassword: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/reset-password`,
  cardConfirmMail: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/confirm-mail`,
  cardLockScreen: `/${rootPaths.authRoot}/${rootPaths.authCardRoot}/lock-screen`,

  agreements: `/${rootPaths.generalRoot}/user-agreements`,
  agreementAdd: `/${rootPaths.generalRoot}/user-agreements/add`,
  agreementEdit: (id = ":id") =>
    `/${rootPaths.generalRoot}/user-agreements/${id}/edit`,
  agreementDetails: (id= ":id") =>
    `/${rootPaths.generalRoot}/user-agreements/${id}`,
  activeAgreement:`/${rootPaths.generalRoot}/active-agreement`,
  apiKeys: `/${rootPaths.generalRoot}/api-keys`,
  clientIds: `/${rootPaths.generalRoot}/client-Ids`,
  calendar: `/${rootPaths.generalRoot}/calendar`,
  chat: `/${rootPaths.generalRoot}/chat`,

  //account management paths
  securityQuestions: `/${rootPaths.accountRoot}/security-questions`,
  passwordReset: `/${rootPaths.accountRoot}/password-reset`,
  accountSecurityQns: `/${rootPaths.accountRoot}/account-security-questions`,
  createNewPassword: `/${rootPaths.accountRoot}/reset-password`,
  changePassword: `/${rootPaths.accountRoot}/change-password`,
  //user paths
  users: `/${rootPaths.olitaskRoot}/users`,
  userEdit: (userId = ":userId") =>
    `/${rootPaths.olitaskRoot}/users/${userId}/edit`,
  userAdd: `/${rootPaths.olitaskRoot}/users/add`,
  userDetails: (userId = ":userId") =>
    `/${rootPaths.olitaskRoot}/users/${userId}`,
  identityDocuments: (userId = ":userId") =>
    `/${rootPaths.olitaskRoot}/users/${userId}/identity-documents`,
  userProfile: `/${rootPaths.userRoot}/profile`,
  profileReviews: (role = ":role", userId = ":userId") =>
    `/${rootPaths.olitaskRoot}/reviews/profile/${role}/${userId}`,

  //task paths
  tasks: `/${rootPaths.olitaskRoot}/tasks/all`,
  taskDetails: (taskId = ":taskId") =>
    `/${rootPaths.olitaskRoot}/tasks/${taskId}`,
  reviewsTaskReviews: (taskId = ":taskId") =>
    `/${rootPaths.olitaskRoot}/reviews/task/${taskId}`,
  taskCategories: `/${rootPaths.olitaskRoot}/tasks/categories`,

  //donation paths
  donationsDashboard: `/${rootPaths.olitaskRoot}/donations/summary`,
  donationsList: `/${rootPaths.olitaskRoot}/donations/list`,
  donationDetails: (donationId) =>
    `/${rootPaths.olitaskRoot}/donations/${
      donationId ? `${donationId}` : ":donationId"
    }`,
  donationsCredit: `/${rootPaths.olitaskRoot}/donations/credits`,
  creditDetails: (creditId) =>
    `/${rootPaths.olitaskRoot}/credits/${
      creditId ? `${creditId}` : ":creditId"
    }`,
  issueCredit: (donationId) =>
    `/${rootPaths.olitaskRoot}/donations/${
      donationId ? `${donationId}` : ":donationId"
    }/issue-credit`,
  donationsDonors: `/${rootPaths.olitaskRoot}/donations/donors`,
  donorDonations: (donorId) =>
    `/${rootPaths.olitaskRoot}/donations/donor/${
      donorId ? `${donorId}` : ":donorId"
    }`,
  donationsPurposes: `/${rootPaths.olitaskRoot}/donations/purposes`,
  creditApplications: `/${rootPaths.olitaskRoot}/donations/credit-applications`,
  applicationDetails: (applicationId) =>
    `/${rootPaths.olitaskRoot}/donations/credit-applications/${
      applicationId ? `${applicationId}` : ":applicationId"
    }`,
  issueCreditFromApplication: (applicationId) =>
    `/${rootPaths.olitaskRoot}/donations/credit-application/${
      applicationId ? `${applicationId}` : ":applicationId"
    }/issue-credit`,

  userAdd: `/${rootPaths.olitaskRoot}/users/add`,
  userEdit: (userId = ":userId") =>
    `/${rootPaths.olitaskRoot}/users/${userId}/edit`,

  roles: `/${rootPaths.accessControlRoot}/roles`,
  roleDetails: (roleId) =>
    `/${rootPaths.accessControlRoot}/roles/${roleId ? `${roleId}` : ":roleId"}`,
  privileges: `/${rootPaths.accessControlRoot}/privileges`,
  assignRole: `/${rootPaths.accessControlRoot}/assign-role`,
};
